<template>
  <div class="app-container">
    <navigation title="检索"></navigation>
    <div class="content">
      <div class="opacList">
        <div class="opac-collection">
          <p class="opacList-title">书籍信息：</p>
          <p class="opacList-title-p">{{ bookMessage.title }}</p>
          <p class="opacList-title-p" v-if="bookMessage.publishHouse">出版社：{{ bookMessage.publishHouse }}</p>
          <p class="opacList-title-p" v-if="bookMessage.author">作者：{{ bookMessage.author }}</p>
          <p class="opacList-title-p" v-if="bookMessage.publishYear">出版年：{{ bookMessage.publishYear }}</p>
          <p class="opacList-title-p" v-if="bookMessage.type">资料类型：{{ bookMessage.type }}</p>
          <p class="opacList-title-p" v-if="bookMessage.isbn">ISBN：<span v-for="item in bookMessage.isbn">{{item}}</span></p>
          <p class="opacList-title-p" v-if="bookMessage.summary">内容提要：{{ bookMessage.summary }}</p>
        </div>
        <div v-for="(val,key,i) in messageList">
          <van-cell title="" v-for="item in val">
            <template #label>
              <p class="message">条码：<span class="message-content">{{ item.barcode?item.barcode:'暂无' }}</span></p>
              <p class="message">单册状态：<span class="message-content">{{ item.itemStatus?item.itemStatus:'暂无' }}</span></p>
              <p class="message">索取号：<span class="message-content">{{ item.callNo?item.callNo:'暂无' }}</span></p>
              <p class="message">子库：<span class="message-content">{{ item.subLibrary?item.subLibrary:'暂无' }}</span></p>
              <p class="message">架位导航：<span class="message-content">{{ item.callNo2?item.callNo2:'暂无' }}</span></p>
              <p class="message">应还日期：<span class="message-content">{{ item.loanDueDate?item.loanDueDate:'暂无' }}</span></p>
              <p class="message">能否预约：
                <span class="message-content">
                <van-button v-if="item.holdAllowed==='Y'" class="opacList-view-btn" @click="appointment(item.barcode)">预约</van-button>
                <span v-else>否</span>
              </span>
              </p>
            </template>
          </van-cell>
        </div>
      </div>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import {Tabbar, TabbarItem, NavBar, Cell, CellGroup, Tab, Tabs, Picker, Toast, Dialog} from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Tab).use(Tabs).use(Picker).use(Dialog)

export default {
  name: 'opacView',
  components: {navigation, version},
  data () {
    return {
      bookMessage: this.$route.query.message,
      messageList: ''
    }
  },
  created () {
    this.view()
  },
  methods: {
    // 返回上一页
    onClickLeft () {
      //页面的返回必须用back才能生效
      this.$router.back()
    },
    // 查看单册信息
    view () {
      let params = {
        base: this.$route.query.message.base,
        docNumber: this.$route.query.message.docNumber
      }
      request('post', '/nlc-api/api/nlc/itemData', params).then(res => {
        console.log('查看单册信息', res)
        if(res.code===200){
          this.messageList = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 预约
    appointment (barcode) {
      let params = {
        barcode: barcode
      }
      console.log('rcardId', this.$store.state.rcardId)
      if (this.$store.state.rcardId) {
        request('post', '/nlc-api/api/nlc/holdReq', params).then(res => {
          console.log('预约', res)
          if (res.code===200 && res.data) {
            Toast.success('预约成功')
          } else  if(res.code===200 && res.data!==false){
            Toast.fail('预约失败')
          } else if(res.code!==200){
            Toast.fail(res.msg)
          }
        })
      } else {
        Dialog.confirm({
          message: '请用读者卡登录？'
        }).then(() => {
          // on confirm
          let url = encodeURI(window.location.href)
          window.location.href = process.env.API_ROOT + '/nlc-api/api/nlc/login?paramUrl='+url
        }).catch(() => {
          // on cancel
        })
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  padding-bottom:1rem;
  overflow-y:scroll;
  min-height: calc(100% - 92px);
  width:100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.content{
  margin-top:1.18rem;
}
.opacList{
  width:6.47rem;
  background:#fff;
  border-radius:8px;
  margin:.26rem .28rem .16rem .28rem;
  padding:.33rem .24rem;
}
.opac-collection{
  width:5.9rem;
  border:15px solid #000;
  border-image-source:url(../../assets/img/opac-title.png);
  border-image-slice:36 36 36 36;
  border-image-repeat:repeat;
}
.opacList-title {
  margin:0;
  padding-bottom:.15rem;
  color:#333333;
  font-size:.36rem;
  font-weight:bold;
  background:rgba(182, 225, 231, 0.3);
}
.opacList-title-p{
  margin:0;
  color:#333333;
  background:rgba(182, 225, 231, 0.3);
  font-size:.28rem;
  line-height:.45rem;
}
.opacList-title-p span{
  display:inline-block;
}
.van-cell {
  padding:10px 4px;
}
.van-cell__title{
  font-size:.32rem;
  color:#444649;
}
.opacList-view-btn{
  width: 1rem;
  height: .48rem;
  background: rgba(0, 128, 149, 0.2);
  border: 2px solid #008095;
  border-radius: 60px;
  color:#008095;
  font-family: SourceHanSerifCN-Bold;
}
.van-button--normal{
  padding:0;
}
.van-cell{
  border-bottom: 1px solid #B3BBC3;
}
.message{
  margin:0;
  line-height:.46rem;
  font-size:.28rem;
}
.message-content{
  position:absolute;
  right:.2rem;
  max-width: 4rem;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/view/opacView/index.vue